import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { Icon } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginLeft: 'auto'
  },
  loader: {
    marginRight: theme.spacing(1.25),
    padding: theme.spacing(0.5)
  },
  rightSection: {
    height: 35,
    minWidth: '30%',
    textAlign: 'right'
  },
  editorFormRowEditor: {
    minWidth: 0,
    width: '100%'
  }
}));

export const EditorInline = props => {
  const classes = useStyles();
  const [saving, setSaving] = useState(false);
  const {
    Component,
    field,
    otherFieldOpen,
    saveFormField,
    value,
    items,
    label,
    locked = false
  } = props;

  const handleSave = async (inlineValue) => {
    setSaving(true);
    await saveFormField({ field, value: inlineValue });
    setSaving(false);
  };

  const disabled = saving || otherFieldOpen || locked;

  const compProps = {
    disabled,
    onChange: value => handleSave(value),
    value,
    items,
    field,
    label
  };

  return (
    <div className={classes.root}>
      <div className={classes.editorFormRowEditor}>
        <Component {...compProps} />
      </div>
      <div className={classes.rightSection}>
        {saving && <div className={classes.loader}><Icon type='loader' /></div>}
      </div>
    </div>
  );
};

EditorInline.propTypes = {
  component: PropTypes.node,
  field: PropTypes.string,
  otherFieldOpen: PropTypes.bool,
  preview: PropTypes.node,
  saveFormField: PropTypes.func.isRequired,
  value: PropTypes.any
};

export default React.memo(EditorInline);
